// packages/shared-hooks/src/clients/useSetClientContactPrimary.ts
//
// `POST /clients/:id/contacts/:contactId/primary` — promotes the target
// contact to primary, demoting the current primary in the SAME tx so the
// partial unique index `(clientId) WHERE isPrimary AND archivedAt IS NULL`
// stays satisfied.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientContactSchema, type ClientContact } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useSetClientContactPrimary(clientId: string, contactId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientContact, unknown, void>({
    mutationFn: () =>
      client.post<ClientContact>(
        `/clients/${clientId}/contacts/${contactId}/primary`,
        undefined,
        {},
        ClientContactSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
